import { z } from 'zod';

export const VALIDATE_SCHEMA = z.object({
  email: z.string().email({ message: 'Некорректные данные' }),
  password: z
    .string()
    .min(8, { message: 'Пароль должен быть не менее 8 символов' })
    .max(64, { message: 'Пароль должен быть не более 64 символов' }),
});
